import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BulkUpload from '../Commons/BulkUpload';

import { CopyIcon } from './Styles/Icons';
import { FlexRow, Bold, InputGroup, Select, MenuItem, SectionRow, InputAdornment, Search, Pagination, ManufacturerMenuItem } from './Styles/AddBulkItems';

import { updateErrorMessage, updateSuccessMessage, updateMessage, updateError } from '../../actions/commonActions';
import {
	setUploadInventoryFileAction,
	setUploadInventoryFileBatch,
	downloadTemplateFile,
	uploadFilledTemplateFile,
	fetchAutocompleteSubCategory,
	fetchAutocompleteSubSubCategory,
} from '../../actions/inventoryActionsV2';
import { fetchSPJBatchJobs, fetchSPJBatchMetric, clearSPJFailed, downloadSPJErrors } from '../../actions/spjActions';

import { SPJ_ACTIONS, getRestrictedFields, STOCK_STATUS, isSubSubCategoryRequired, hideDSOInfo } from '../../commons/utils';

class AddBulkItems extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			filteredManufacturerOptions: [],
			filteredManufacturerCount: 0,
			manufacturerSearchText: '',
			manufacturerPageNumber: 0,
			manufacturerPageSize: 25,
			manufacturer: '',
			mappedSupplier: '',
			categoryOptions: [],
			category: '',
			subCategory: '',
			subSubCategory: '',
			packaging: '',
			mappedDSOIds: '',
		};
	}

	async componentDidMount() {
		this.setDefaultState();
	}

	async componentDidUpdate(prevProps, prevState) {
		if (prevState.manufacturerSearchText !== this.state.manufacturerSearchText) {
			let { manufacturerOptions } = this.props;
			let { manufacturerSearchText, manufacturerPageSize } = this.state;

			let manufacturerList = [];
			manufacturerList = manufacturerOptions.filter((option) => option.name.toUpperCase().includes(manufacturerSearchText.toUpperCase()));
			this.setState({
				manufacturerPageNumber: 0,
				filteredManufacturerCount: manufacturerList.length,
				filteredManufacturerOptions: manufacturerList.slice(0, manufacturerPageSize),
			});
		}

		if (prevState.manufacturerPageNumber !== this.state.manufacturerPageNumber) {
			let { manufacturerOptions } = this.props;
			let { manufacturerPageNumber, manufacturerPageSize } = this.state;

			this.setState({
				filteredManufacturerOptions: manufacturerOptions.slice(manufacturerPageNumber * manufacturerPageSize, (manufacturerPageNumber + 1) * manufacturerPageSize),
			});
		}

		if (prevState.manufacturerPageSize !== this.state.manufacturerPageSize) {
			let { manufacturerOptions } = this.props;
			let { manufacturerPageSize } = this.state;

			this.setState({
				manufacturerPageNumber: 0,
				filteredManufacturerOptions: manufacturerOptions.slice(0, manufacturerPageSize),
			});
		}

		if (this.state.category && prevState.category !== this.state.category) {
			let { category } = this.state;
			await this.props.fetchAutocompleteSubCategory(category);
			this.setState({ subCategory: '' });
		}

		if (isSubSubCategoryRequired(this.props.groupId) && this.state.subCategory && prevState.subCategory !== this.state.subCategory) {
			let { category, subCategory } = this.state;
			await this.props.fetchAutocompleteSubSubCategory(category, subCategory);
			this.setState({ subSubCategory: '' });
		}
	}

	setDefaultState = async (next = null) => {
		let { manufacturerOptions } = this.props;

		this.setState(
			{
				manufacturerPageNumber: 0,
				filteredManufacturerOptions: (manufacturerOptions || []).slice(0, this.state.manufacturerPageSize),
				filteredManufacturerCount: (manufacturerOptions || []).length,
				manufacturer: '',
				mappedSupplier: '',
				packaging: '',
				category: '',
				subCategory: '',
				subSubCategory: '',
				mappedDSOIds: '',
			},
			next
		);
	};

	handleInput = (key, value, next = null) => {
		this.handleCopyInput(value);
		this.setState(
			{ [key]: value },
			next
		);
	};

	handleCopyInput = (value) => {
		navigator.clipboard.writeText(value);
		this.props.updateMessage(true, 'Copied to clipboard');
	};

	downloadTemplateFile = async (action, onError) => {
		await this.props.downloadTemplateFile(action, onError);
	};

	uploadFilledTemplateFile = async (action, formData, onSuccess, onError) => {
		await this.props.uploadFilledTemplateFile(action, formData, onSuccess, onError);
	};

	render() {
		let {
			manufacturer,
			mappedSupplier,
			packaging,
			category,
			subCategory,
			subSubCategory,
			mappedDSOIds,
			filteredManufacturerCount,
			filteredManufacturerOptions,
			manufacturerSearchText,
			manufacturerPageNumber,
			manufacturerPageSize,
		} = this.state;
		let {
			open,
			updateItems,
			uploadInventoryFileAction,
			uploadInventoryFileBatch,
			uploadInventoryFileType,
			groupId,
			mappedSupplierOptions,
			packagingOptions,
			mappedDSOOptions,
			categoryOptions,
			subCategoryOptions,
			subSubCategoryOptions,
			restrictedFields,
			allowZeroPrice,
		} = this.props;

		return open ? (
			<BulkUpload
				open={open}
				title={updateItems ? 'Update Items And Status In Bulk' : 'Add Items In Bulk'}
				spjAction={updateItems ? SPJ_ACTIONS.INVENTORY_UPDATE : SPJ_ACTIONS.INVENTORY_CREATE}
				uploadFileAction={uploadInventoryFileAction || ''}
				uploadFileBatch={uploadInventoryFileBatch || ''}
				uploadFileType={uploadInventoryFileType || ''}
				onClose={this.props.toggle}
				onSuccess={this.props.onSuccess}
				downloadTemplateFile={this.downloadTemplateFile}
				uploadFilledTemplateFile={this.uploadFilledTemplateFile}
				setUploadFileAction={this.props.setUploadInventoryFileAction}
				setUploadFileBatch={this.props.setUploadInventoryFileBatch}
			>
				<FlexRow style={{ margin: '0.5rem auto', textAlign: 'center' }}>Download the sample file and add item details and upload again to add multiple items to inventory at once.</FlexRow>

				<FlexRow style={{ justifyContent: 'center', textAlign: 'center', paddingTop: '0.5rem' }}>
					<Bold>Rules:</Bold>
				</FlexRow>

				<FlexRow style={{ alignSelf: 'center', paddingBottom: '0.5rem' }}>
					<ul style={{ listStyle: 'circle' }}>
						<li>
							<Bold>Do not alter</Bold> the file headers.
						</li>

						{updateItems ? (
							<>
								<li>
									Details for <Bold>locked items</Bold> cannot be updated.
								</li>

								<li>
									<Bold>Item ID</Bold> is a mandatory field.
								</li>
							</>
						) : null}

						<li>
							<Bold>Item ID, Item Name, Manufacturer, Manufacturer SKU, Item Description, Status, Price Per Item, Category, UOM</Bold> are mandatory fields.
						</li>

						<li>
							<Bold>Item Name</Bold> should be at max 150 characters in length.
						</li>

						<li>
							<Bold>Item ID</Bold> should be unique. It cannot contain underscore(_) and colon(:).
						</li>

						<li>
							<Bold>Manufacturer</Bold> should be at max 50 characters in length. It can be selected and copied from the dropdown given below.
						</li>

						<li>
							<Bold>Manufacturer SKU</Bold> should be at max 25 characters in length.
						</li>

						<li>
							<Bold>Status</Bold> should have the following values only : [
							<Bold>
								{Object.keys(STOCK_STATUS)
									.map((code) => code)
									.join(', ')}
							</Bold>
							].
						</li>

						<li>
							Multiple URLs should be separated using a <Bold>||</Bold> symbol.
						</li>

						<li>
							<Bold>UOM</Bold> should be only among the values given in the dropdown in the template.
						</li>

						<li>
							<Bold>Packaging</Bold> should be only among the values given in the dropdown in the template.
						</li>

						<li>
							<Bold>Quantity</Bold> should be a positive numeric value. If <Bold>Packaging</Bold> is provided then <Bold>Quantity</Bold> becomes mandatory and vice versa.
						</li>

						<li>
							<Bold>Minimum Quantity, Maximum Quantity, Incremental Quantity</Bold> should be a positive numeric value.
						</li>

						<li>
							<Bold>Is Special Market?</Bold> should be following values only : [<Bold>{['TRUE', 'FALSE'].map((item) => item).join(', ')}</Bold>
							].
						</li>

						{!(hideDSOInfo(groupId) || (restrictedFields.includes('group_ids') && restrictedFields.includes('group_private'))) ? (
							<>
								<li>
									<Bold>Map To Particular DSOs</Bold> can be selected and copied from the dropdown given below. Multiple DSOs have to be separated using a <Bold>||</Bold> symbol. For
									example: "DSO-1 || DSO-2"
								</li>

								<li>
									<Bold>Make item available only for selected DSOs?</Bold> should be following values only : [<Bold>{['TRUE', 'FALSE'].map((item) => item).join(', ')}</Bold>
									].
								</li>
							</>
						) : null}

						<li>
							<Bold>Category</Bold> should be only among the values given in the dropdown in the template. Depending on <Bold>Category</Bold>selected,{' '}
							<Bold>Subcategory {isSubSubCategoryRequired(groupId) ? ', Sub Sub Category' : ''}</Bold>
							can be selected and copied from the dropdown given below.
						</li>

						<li>
							<Bold>Alternate Text</Bold> should contain alphabets, numbers, hyphens and spaces only. It should be at max 100 characters in length.
						</li>

						{!restrictedFields.includes['keywords'] ? (
							<li>
								<Bold>Keywords</Bold> should contain alphabets, numbers and hyphens only. Each keyword can be at max 20 characters in length. Maximum 10 keywords are allowed. Multiple
								keywrds have to be separated using a <Bold>||</Bold> symbol. For example: "Gloves || Size-2 || Blue"
							</li>
						) : null}

						<li>
							<Bold>Attributes</Bold> have to follow a specific format. Attribute name and value should be written as <Bold>name : value</Bold>. Both name and value should be at max 50
							characters in length. Multiple attributes have to be separated using a <Bold>||</Bold> symbol. For example: "Color : Blue || Size : Large || Length : 1m"
						</li>

						<li>
							<Bold>Price Per Item</Bold> should be a {allowZeroPrice ? 'zero or positive' : 'positive'} numeric value, without currency symbol.
						</li>

						<li>
							You can add <Bold>Scheduled At</Bold> timestamp to publish product on a future date. It should be a future date and should follow a specific format <Bold>YYYY-MM-DD</Bold>.
						</li>
					</ul>
				</FlexRow>

				<SectionRow>
					<InputGroup label='Find Manufacturer Alias'>
						<Select
							name='manufacturer'
							placeholder='Select value'
							value={manufacturer || ''}
							disabled={false}
							onChange={(e) => {
								this.handleInput('manufacturer', e.target.value);
							}}
							endAdornment={
								<InputAdornment>
									<CopyIcon
										onClick={(e) => {
											this.handleCopyInput(manufacturer);
										}}
									/>
								</InputAdornment>
							}
						>
							<MenuItem
								disabled={false}
								divider
								onClickCapture={(e) => {
									e.stopPropagation();
									e.preventDefault();
								}}
								onKeyDown={(e) => e.stopPropagation()}
							>
								<Search
									searchText={manufacturerSearchText}
									placeholder={'Search Manufacturer'}
									searchOnChange={true}
									onSearchHandler={(value) => this.setState({ manufacturerSearchText: value })}
								/>
							</MenuItem>

							{filteredManufacturerCount === 0 ? (
								<MenuItem
									key={'NO MANUFACTURER OPTIONS AVAILABLE'}
									value={''}
									disabled={true}
								>
									NO MANUFACTURER OPTIONS AVAILABLE
								</MenuItem>
							) : null}

							{filteredManufacturerOptions.map((item) => (
								<ManufacturerMenuItem
									key={item.value}
									value={item.value}
									disabled={item.disabled}
									onClick={(e) => { }}
								>
									{item.name}
								</ManufacturerMenuItem>
							))}

							<Pagination
								component='div'
								count={filteredManufacturerCount || 0}
								page={manufacturerPageNumber}
								onPageChange={(e, page) => {
									this.setState({ manufacturerPageNumber: parseInt(page, 10) });
								}}
								rowsPerPage={manufacturerPageSize}
								onRowsPerPageChange={(e) => {
									this.setState({ manufacturerPageSize: parseInt(e.target.value, 10), manufacturerPageNumber: 0 });
								}}
							/>
						</Select>

						{manufacturer ? (
							<span>
								Use <Bold>{manufacturer}</Bold> in XLSX
							</span>
						) : null}
					</InputGroup>

					{!(hideDSOInfo(groupId) || restrictedFields.includes('group_ids')) ? (
						<InputGroup label='Find DSO Alias'>
							<Select
								multiple
								name={'mapped_dso_ids'}
								placeholder='Select value'
								value={mappedDSOIds.split(' || ')}
								disabled={false}
								onChange={(e) => {
									this.handleInput('mappedDSOIds', e.target.value?.filter(item => item).join(' || '));
								}}
								endAdornment={
									<InputAdornment>
										<CopyIcon
											onClick={(e) => {
												this.handleCopyInput(mappedDSOIds);
											}}
										/>
									</InputAdornment>
								}
							>
								{!mappedDSOOptions.length ? (
									<MenuItem
										key={'NO DSO OPTIONS AVAILABLE'}
										value={''}
										disabled={true}
									>
										NO DSO OPTIONS AVAILABLE
									</MenuItem>
								) : null}

								{mappedDSOOptions.map((item) => (
									<MenuItem
										key={item.name}
										value={item.name}
										disabled={item.disabled}
									>
										{item.name}
									</MenuItem>
								))}
							</Select>

							{mappedDSOIds ? (
								<span>Use <Bold>{mappedDSOIds}</Bold> in XLSX</span>
							) : null}
						</InputGroup>
					) : null}

					<InputGroup label='Find Category Alias'>
						<Select
							name={'category'}
							placeholder='Select value'
							value={category || ''}
							disabled={false}
							onChange={(e) => {
								this.handleInput('category', e.target.value);
							}}
							endAdornment={
								<InputAdornment>
									<CopyIcon
										onClick={(e) => {
											this.handleCopyInput(category);
										}}
									/>
								</InputAdornment>
							}
						>
							{!categoryOptions.length ? (
								<MenuItem
									key={'NO CATEGORY OPTIONS AVAILABLE'}
									value={''}
									disabled={true}
								>
									NO CATEGORY OPTIONS AVAILABLE
								</MenuItem>
							) : null}

							{categoryOptions.map((item) => (
								<MenuItem
									key={item.value}
									value={item.value}
									disabled={item.disabled}
								>
									{item.name}
								</MenuItem>
							))}
						</Select>

						{category ? (
							<span>
								Use <Bold>{category}</Bold> in XLSX
							</span>
						) : null}
					</InputGroup>

					<InputGroup label='Find Sub Category Alias'>
						<Select
							name={'sub_category'}
							placeholder='Select value'
							value={subCategory || ''}
							disabled={!category}
							onChange={(e) => {
								this.handleInput('subCategory', e.target.value);
							}}
							endAdornment={
								<InputAdornment>
									<CopyIcon
										onClick={(e) => {
											this.handleCopyInput(subCategory);
										}}
									/>
								</InputAdornment>
							}
						>
							{!subCategoryOptions.length ? (
								<MenuItem
									key={'NO SUB CATEGORY OPTIONS AVAILABLE'}
									value={''}
									disabled={true}
								>
									NO SUB CATEGORY OPTIONS AVAILABLE
								</MenuItem>
							) : null}

							{subCategoryOptions.map((item) => (
								<MenuItem
									key={item.value}
									value={item.value}
									disabled={item.disabled}
								>
									{item.name}
								</MenuItem>
							))}
						</Select>

						{subCategory ? (
							<span>
								Use <Bold>{subCategory}</Bold> in XLSX
							</span>
						) : null}
					</InputGroup>

					{isSubSubCategoryRequired(groupId) ? (
						<InputGroup label='Find Sub Sub Category Alias'>
							<Select
								name={'sub_sub_category'}
								placeholder='Select value'
								value={subSubCategory || ''}
								disabled={!subCategory}
								onChange={(e) => {
									this.handleInput('subSubCategory', e.target.value);
								}}
								endAdornment={
									<InputAdornment>
										<CopyIcon
											onClick={(e) => {
												this.handleCopyInput(subSubCategory);
											}}
										/>
									</InputAdornment>
								}
							>
								{!subSubCategoryOptions.length ? (
									<MenuItem
										key={'NO SUB SUB CATEGORY OPTIONS AVAILABLE'}
										value={''}
										disabled={true}
									>
										NO SUB SUB CATEGORY OPTIONS AVAILABLE
									</MenuItem>
								) : null}

								{subSubCategoryOptions.map((item) => (
									<MenuItem
										key={item.value}
										value={item.value}
										disabled={item.disabled}
									>
										{item.name}
									</MenuItem>
								))}
							</Select>

							{subSubCategory ? (
								<span>
									Use <Bold>{subSubCategory}</Bold> in XLSX
								</span>
							) : null}
						</InputGroup>
					) : null}

					{/* <InputGroup label="Find Supplier Alias">
                        <Select
                            name="mapped_supplier"
                            placeholder="Select value"
                            value={(mappedSupplier || "")}
                            disabled={false}
                            onChange={(e)=>{
                                this.handleInput("mappedSupplier", e.target.value)
                            }}
                            endAdornment={
                                <InputAdornment>
                                    <CopyIcon onClick={(e) => {this.handleCopyInput(mappedSupplier)}}/>
                                </InputAdornment>
                            }
                        >
                            {!(mappedSupplierOptions.length)
                            ?    <MenuItem 
                                    key={"NO SUPPLIER OPTIONS AVAILABLE"}
                                    value={""} 
                                    disabled={true}
                                >
                                    NO SUPPLIER OPTIONS AVAILABLE
                                </MenuItem>
                            :null
                            }

                            {mappedSupplierOptions.map((item) => (
                                <MenuItem 
                                    key={item.value} 
                                    value={item.value} 
                                    disabled={item.disabled}
                                >
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                        
                        {mappedSupplier
                        ?   <span>Use <Bold>{mappedSupplier}</Bold> in XLSX</span>
                        :   null
                        }
                    </InputGroup> */}
				</SectionRow>
			</BulkUpload>
		) : null;
	}
}

const mapStateToProps = (state) => {
	let restrictedFields = getRestrictedFields(state.session, state.supplier);

	return {
		groupId: state.session.groupId,
		uploadInventoryFileAction: state.inventory.uploadInventoryFileAction || '',
		uploadInventoryFileBatch: state.inventory.uploadInventoryFileBatch || '',
		uploadInventoryFileType: state.inventory.uploadInventoryFileType || '',
		manufacturerOptions: state.inventory.manufacturerOptions || [],
		mappedSupplierOptions: state.inventory.mappedSupplierOptions || [],
		packagingOptions: state.inventory.packagingOptions || [],
		mappedDSOOptions: state.inventory.mappedDSOOptions || [],
		categoryOptions: state.inventory.categoryOptions || [],
		subCategoryOptions: state.inventory.subCategoryOptions || [],
		subSubCategoryOptions: state.inventory.subSubCategoryOptions || [],
		restrictedFields: restrictedFields,
		allowZeroPrice: state?.supplier?.sellerPortalConfig?.allow_zero_pricing || false,
	};
};

const mapDispatch = {
	setUploadInventoryFileAction,
	downloadTemplateFile,
	uploadFilledTemplateFile,
	setUploadInventoryFileBatch,
	fetchAutocompleteSubCategory,
	fetchAutocompleteSubSubCategory,
	fetchSPJBatchJobs,
	fetchSPJBatchMetric,
	clearSPJFailed,
	downloadSPJErrors,
	updateError,
	updateErrorMessage,
	updateMessage,
	updateSuccessMessage,
};

export default withRouter(connect(mapStateToProps, mapDispatch)(AddBulkItems));
